import React from "react";
import { useDispatch } from "react-redux";
import { addToCart } from "../redux/products/actions";

const ProductCard = ({ item }) => {
  const dispatch = useDispatch();

  const handleAddToCart = () => {
    dispatch(addToCart(item));
  };

  return (
    <div className="lws-productCard">
      <img className="lws-productImage" src={item?.imgUrl} alt="product" />
      <div className="p-4 space-y-2">
        <h4 className="lws-productName">{item?.name}</h4>
        <p className="lws-productCategory">{item?.category}</p>
        <div className="flex items-center justify-between pb-2">
          <p className="productPrice">
            BDT <span className="lws-price">{item?.price}</span>
          </p>
          <p className="productQuantity">
            QTY <span className="lws-quantity">{item?.quantity}</span>
          </p>
        </div>
        <button
          disabled={item.quantity === 0 && "disable"}
          onClick={handleAddToCart}
          className="lws-btnAddToCart"
        >
          Add To Cart
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
